import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { 
  Folder,
  Brain,
  Target,
  Sparkles,
  Wallet,
  Heart,
  Briefcase,
  GraduationCap,
  Home,
  type LucideIcon
} from "lucide-react"

export function cn(...inputs: ClassValue[]) {
  const result = clsx(inputs)
  return twMerge(result != null && result !== "" ? result : "")
}

export const topicIconOptions: Array<{ name: string; icon: LucideIcon; color: string }> = [
  { name: "folder", icon: Folder, color: "text-slate-500" },
  { name: "brain", icon: Brain, color: "text-blue-500" },
  { name: "target", icon: Target, color: "text-green-500" },
  { name: "sparkles", icon: Sparkles, color: "text-purple-500" },
  { name: "wallet", icon: Wallet, color: "text-emerald-500" },
  { name: "heart", icon: Heart, color: "text-pink-500" },
  { name: "briefcase", icon: Briefcase, color: "text-orange-500" },
  { name: "graduation", icon: GraduationCap, color: "text-indigo-500" },
  { name: "home", icon: Home, color: "text-amber-500" },
]

export function getTopicIcon(iconName: string | null | undefined): { icon: LucideIcon; color: string } {
  const found = topicIconOptions.find(opt => opt.name === iconName)
  return found || topicIconOptions[0]
}
